export const getFileExtension = (fileName: string): string =>
    fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();
